import ltiInstance from './instances/lti';
import devInstance from './instances/dev';
import { isLtiRoute } from './util';

const instance = () => (isLtiRoute() ? ltiInstance : devInstance);

export const getData = (service) => instance().get(service);
export const postData = (service, body) => instance().post(service, body);
export const patchData = (service, body) => instance().patch(service, body);
export const putData = (service, body) => instance().put(service, body);
export const deleteData = (service) => instance().delete(service);
